import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { EstimateType } from "@/types/db/estimates";
import { estimateService } from "@/services/estimateService";

interface EstimateEditProviderProps extends Omit<EntityEditProviderProps<EstimateType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function EstimateEditProvider({ children, entityData, loading, onSaveSuccess }: EstimateEditProviderProps) {
  const handleSave = async (formData: Partial<EstimateType>): Promise<EstimateType> => {
    if (!entityData?.id) {
      throw new Error("No estimate ID available");
    }

    // Clean the data - remove read-only fields before sending to database
    const { id, created_at, ...cleanFormData } = formData;

    const updatedEstimate = await estimateService.updateEstimate(entityData.id, cleanFormData);
    return updatedEstimate;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Estimate"
    >
      {children}
    </EntityEditProvider>
  );
}
